export default __webpack_public_path__ + "static/media/portfolio-91.6a0b5848.jpg";